import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import firstBy from 'thenby'
import Select from 'react-select'
import colors from '../../../configuration/colors'
import reactSelectBaseStyles from '../../../configuration/ReactSelect'
import FlexContainer from '../../styled/FlexContainer'
import EvidenceStatements from '../../mini/Skills/EvidenceStatements'

const skillsStyles = Object.assign({}, reactSelectBaseStyles)

skillsStyles.singleValue = provided => {
  return {
    ...provided,
    backgroundColor: colors.white,
    padding: '0 4px',
    margin: '0',
    cursor: 'pointer',
    color: colors.black,
    fontSize: '14px',
    fontWeight: '400'
  }
}

skillsStyles.container = provided => {
  return {
    ...provided,
    width: '100%',
    height: '44px',
    zIndex: '20'
  }
}

skillsStyles.control = (provided, state) => {
  return {
    ...provided,
    width: '100%',
    height: '44px',
    padding: '2px 0',
    boxShadow: 'none',
    borderColor: `${colors.rock} !important`,
    background: colors.white,
    zIndex: '20'
  }
}

skillsStyles.input = provided => {
  return {
    ...provided,
    color: colors.black,
    fontSize: '14px',
    fontWeight: '400'
  }
}

skillsStyles.option = (provided, state) => {
  return {
    ...provided,
    background: state.isFocused ? '#f1f1f1' : colors.white,
    color: colors.black,
    textAlign: 'left',
    fontSize: '14px',
    fontWeight: '400',
    cursor: 'pointer',
    paddingLeft: '25px'
  }
}

export default class SkillSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      skills: this.getSkillOptions(this.props.frameworkSkills)
    }

    this._onSkillSelectBound = this._onSkillSelect.bind(this)
  }

  render() {
    const selectedSkill = this.getSelectedSkill()
    const skillOptions = this.getSkillOptions(this.props.frameworkSkills)

    return (
      <Fragment>
        <FlexContainer
          style={{ justifyContent: 'unset', marginBottom: '15px' }}
        >
          <Select
            autoFocus
            isClearable={false}
            isSearchable
            options={skillOptions}
            value={selectedSkill}
            onChange={this._onSkillSelectBound}
            placeholder="Select or type in a skill"
            noOptionsMessage={() =>
              'There are no records that match your search.'
            }
            styles={skillsStyles}
          />
        </FlexContainer>
        {selectedSkill && (
          <div style={{ textAlign: 'left' }}>
            <EvidenceStatements
              evidenceStatements={selectedSkill.evidenceStatements}
              isTooltip={false}
            />
          </div>
        )}
      </Fragment>
    )
  }

  _onSkillSelect(selectedOption) {
    this.props.onSkillSelect(selectedOption, this.props.index)
  }

  getSelectedSkill() {
    const skill =
      this.props.frameworkSkills.find(s => s.id === this.props.skillId) || null

    if (skill) {
      return {
        value: skill.id,
        label: skill.name,
        evidenceStatementSetId: skill.evidence_statement_set_id,
        evidenceStatements: skill.evidence_statements.sort(
          firstBy('sort_order')
        )
      }
    }

    return null
  }

  getSkillOptions(skills) {
    const skillOptions = skills
      // filter out skills that are selected in other skill cards
      .filter(
        s => !this.props.selectedSkills.map(ss => ss.skillId).includes(s.id)
      )
      .sort(firstBy('name'))
      .map(fs => ({
        value: fs.id,
        label: fs.name,
        evidenceStatementSetId: fs.evidence_statement_set_id,
        evidenceStatements: fs.evidence_statements.sort(firstBy('sort_order'))
      }))

    return skillOptions
  }
}

SkillSelect.propTypes = {
  dispatch: PropTypes.func,
  index: PropTypes.number,
  skillId: PropTypes.number,
  fetchSkills: PropTypes.func,
  onSkillSelect: PropTypes.func,
  selectedSkills: PropTypes.array,
  quest: PropTypes.object,
  frameworkSkills: PropTypes.array
}
